import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import useFilterStore from "@COMPONENTS/product/pages/localList/common/filterHook";
import {StackList, StackListItem} from "@FRAMEWORK/ui/desktop/list";

const LocalSortFilterComponent = () => {
	const {getFilter, setFilter} = useFilterStore();
	const key = "sort";
	const Rating = [
		// 상품리스트 필터
		{text: "추천순", value: "sortOrder", key, asc: true},
		{text: "인기순", value: "rervTourlistCnt", key, asc: false},
		{text: "낮은가격순", value: "minPrice", key, asc: true},
		{text: "높은가격순", value: "minPrice", key, asc: false},
		{text: "고객평점순", value: "rvwAvgScore", key, asc: false},
	];

	const handleClick = e => {
		const {value, text, asc}: {value: string; text: string; asc: string} = e.target.dataset;
		const setArr = getFilter()?.filter(v => v.key !== key);
		value && setArr.push({key, value, text, asc: asc === "true"});
		setFilter(setArr);
	};

	return (
		<StackList cursor={"pointer"}>
			{Rating.map((item, index) => (
				<StackListItem
					key={index}
					onClick={handleClick}
					isActive={getFilter()?.some(v => v.text === item.text && v.key === key) || false}
					data-asc={item.asc}
					data-value={item.value}
					data-text={item.text}
				>
					{item.text}
				</StackListItem>
			))}
		</StackList>
	);
};

const LocalSortFilter = () => (
	<ErrorBoundary logMsg="SortFilter Error">
		<LocalSortFilterComponent />
	</ErrorBoundary>
);

export default LocalSortFilter;
